export const environment = {
    production: false,
    clientId: 'CMD',
    backendUrl: window['env']['backendUrl'] || 'https://cmd-coleta-backend-hom.saude.gov.br',
    // backendUrl: window['env']['backendUrl'] || 'http://localhost:8081/cmdcoleta',
    frontendUrl: window['env']['frontendUrl'] || 'https://cmd-coleta-hom.saude.gov.br/#/login?login_executado=true',
    urlApp: window['env']['urlApp'] || 'https://cmd-coleta-hom.saude.gov.br',
    urlScpa : window['env']['urlScpa'] || 'https://scpa-hom.saude.gov.br/usuario/novo',
    manual : window['env']['manual'] || 'https://drive.google.com/file/d/16kTrPoHt7SYKxyD7QmP_80GCFBg0iMAs/view'
};